import React, { useEffect, useState, Fragment } from 'react';
import { Grid, Loader } from 'semantic-ui-react';
import ApplicationList from './ApplicationList';
import { useDispatch, useSelector } from 'react-redux';
import ApplicationListItemPlaceholder from './ApplicationListItemPlaceholder';
import ApplicationFilters from './ApplicationFilters';
import { fetchApplications } from '../libraryActions';
import { Helmet } from 'react-helmet';
import { languages } from '../applicationForm/SelectData/languages';
import { media_types } from '../applicationForm/SelectData/media_types';
import { levels } from '../applicationForm/SelectData/levels';
import { RETAIN_STATE } from '../libraryConstants';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Hits, SearchBox } from 'react-instantsearch-dom';
import ResultsList from './ResultsList';

const algoliaClient = algoliasearch(
  'MYW9W6JVBO',
  '274b1077e0fa03784618278bdd1a1bb9'
);

//import ToggleSwitch from '../../../app/common/form/ToggleSwitch';

export default function LibraryDashboard({ match }) {
  const limit = 10;
  const dispatch = useDispatch();
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  const searchClient = {
    ...algoliaClient,
    search(requests) {
      if (requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
          })),
        });
      }

      setIsSearch(true);
      return algoliaClient.search(requests);
    },
  };

  const term1 = (match.params && match.params.term1) || null;
  const term2 = (match.params && match.params.term2) || null;
  const term3 = (match.params && match.params.term3) || null;

  let initLang, initLevel, initMedia;

  if (match) {
    initLang = checkForMatch('language', languages, initLang);
    initLevel = checkForMatch('level', levels, initLevel);
    initMedia = checkForMatch('media_type', media_types, initMedia);
  }

  const {
    applications,
    moreApplications,
    language,
    level,
    media_type,
    lastVisible,
    retainState,
    showGeneric,
  } = useSelector((state) => state.library);
  const { loading } = useSelector((state) => state.async);
  const [loadingInitial, setLoadingInitial] = useState(false);

  useEffect(() => {
    if (retainState) return;
    setLoadingInitial(true);
    dispatch(
      fetchApplications(
        language || initLang,
        level || initLevel,
        media_type || initMedia,
        limit,
        showGeneric
      )
    ).then(() => {
      setLoadingInitial(false);
    });
    return () => {
      dispatch({ type: RETAIN_STATE });
    };
  }, [
    dispatch,
    initLang,
    initLevel,
    initMedia,
    language,
    level,
    media_type,
    retainState,
    showGeneric,
    isSearch,
  ]);

  //if (loading) return <LoadingComponent />;

  function pluralize(term) {
    if (term && term.substr(term.length - 1, 1) !== 's') term += 's';
    return term;
  }

  function handleSetIsSearch(val) {
    setIsSearch(val);
  }

  function handleFetchNextApplications() {
    dispatch(
      fetchApplications(language, level, media_type, limit, lastVisible)
    );
  }

  function checkForMatch(title, arr, defaultVal) {
    let val;
    arr.forEach((item) => {
      let tmp = item['value'].toLowerCase();
      if (
        tmp === term1?.toLowerCase() ||
        tmp === term1?.toLowerCase() + 's' ||
        tmp === term2?.toLowerCase() ||
        tmp === term2?.toLowerCase() + 's' ||
        tmp === term3?.toLowerCase() ||
        tmp === term3?.toLowerCase() + 's'
      ) {
        val = item['value'];
        return;
      }
    });

    return val || defaultVal;
  }

  //if (loading) return <LoadingComponent />;

  return (
    <Fragment>
      <Helmet>
        <title>Search Page</title>
      </Helmet>
      <Grid>
        <Grid.Column
          width={16}
          style={{ textAlign: 'center' }}
          className='pageHeader'
        >
          {language ||
          level ||
          media_type ||
          initLang ||
          initLevel ||
          initMedia ? (
            <h1 className='pageTitle'>
              {(language && language) || (initLang && initLang)}{' '}
              {level && level}{' '}
              {media_type ? pluralize(media_type) : 'Resources'}
            </h1>
          ) : (
            <h1 className='pageTitle'>Search The Library</h1>
          )}
        </Grid.Column>
      </Grid>
      <Grid className='pageBody'>
        <Grid.Column width={16} className='mobile only'>
          <ApplicationFilters
            initLang={initLang}
            initLevel={initLevel}
            initMedia={initMedia}
            loading={loading}
            setShowAdvanced={setShowAdvanced}
            filterType='mobile'
            handleSetIsSearch={handleSetIsSearch}
          />
        </Grid.Column>
        <Grid.Column computer={10} mobile={16}>
          {loadingInitial && (
            <Fragment>
              <ApplicationListItemPlaceholder />
              <ApplicationListItemPlaceholder />
            </Fragment>
          )}
          <InstantSearch
            searchClient={searchClient}
            indexName='languagelearninglibrary_prod'
          >
            <SearchBox searchAsYouType={false} />
            {isSearch ? (
              <Hits hitComponent={ResultsList} showAdvanced={showAdvanced} />
            ) : (
              <ApplicationList
                applications={applications}
                getNextApplications={handleFetchNextApplications}
                loading={loading}
                loadingInitial={loadingInitial}
                moreApplications={moreApplications}
                showAdvanced={showAdvanced}
                isSearch={isSearch}
              />
            )}
          </InstantSearch>
        </Grid.Column>
        <Grid.Column width={6} className='computer only'>
          <ApplicationFilters
            initLang={initLang}
            initLevel={initLevel}
            initMedia={initMedia}
            loading={loading}
            setShowAdvanced={setShowAdvanced}
          />
        </Grid.Column>
        <Grid.Column computer={10} mobile={16}>
          <Loader active={loading} />
        </Grid.Column>
      </Grid>
    </Fragment>
  );
}
